import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { TopMenu, AccountVerify, Button } from "../../components";
import { setTheme } from "../../utils/themes";
import Home from "../home";
import Footer from "../footer/index";
import Menu from "../templates/menu/index";
import HotNews from "../hotNews";
import CategoryNwsPage from "../categoryNewsPage";
import { getNewsBullets } from "../news/service/news.service";
import { getLanguage } from "../../utils/environment";
import { useLocation } from "react-router-dom";
import {
  AdvertisementModal,
  EmailChangeModal,
  EmailVerificationModal,
  MobileMenuModal,
  ProfileCompleteModal,
} from "../modal";
import { useDispatch, useSelector } from "react-redux";
import { getIPAddress } from "../../utils/browserMeta";
import { getInsight, removeInsight, setInsight } from "../../utils/auth";
import {
  createNewInsight,
  createSiteImpression,
} from "./services/insight.service";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  HomeModalAd,
} from "../templates/advertiesments";
import TagNewsPage from "../tagsNews";
import { LiveFeed } from "../home/templates";
import { notification } from "antd";
import { openProfileCreateModal } from "../AdsPlatform/redux/actions";
import { getAllTags } from "../Tags/service/tags.service";
import { setTagsList } from "../Tags/redux/actions";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { HomeAdViewModal } from "../modal";
import { getCookie, setCookie } from "../../utils/cookie";
import { openHomeAdModal } from "./redux/actions";

const lan = getLanguage();

const Index = (props) => {
  const { isOpenMobileMenuModal, newsUser, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer,
  );
  const {
    isOpenEmailVerificationModal,
    isOpenEmailChangeModal,
    isOpenProfileCreateModal,
  } = useSelector(({ adsUserReducer }) => adsUserReducer);
  const tagList = useSelector((state) => state.tagsReducer.tagsList);
  const dispatch = useDispatch();

  const { location } = props;
  const { pathname } = useLocation();

  const [isOpenAdvertisementModal, setIsOpenAdvertisementModal] =
    React.useState(false);
  const [category, setCategory] = React.useState("");
  const [tag, setTag] = React.useState("");
  const [newsBullets, setNewsBullets] = React.useState([]);
  const [bgImage, setBgImage] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  // +2 for "Home" and "Contact us"
  const menusList = useSelector((state) => state.menuReducer.menuList);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      console.log(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  async function fetchNewsBullets() {
    try {
      const response = await getNewsBullets();
      console.log("get news bullets", response);
      if (response?.data) {
        setNewsBullets(response?.data?.news);
      } else {
        setNewsBullets([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleChangeImage = (image) => {
    if (image) {
      setBgImage(image);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTheme("light");
    setIsOpenAdvertisementModal(false);
    // const fetchData = async () => {
    //   await fetchNewsBullets();
    // };

    //================= User insight =============================
    //removeInsight();
    // let browserMeta = getBrowserMeta();
    let insightBody = {};

    async function handleInsight() {
      try {
        // Get the geolocationimage
        // const position = await getGeoLocation();
        // const { latitude, longitude, accuracy, timestamp } = position?.coords;

        // Wait for all promises to resolve
        const [ip] = await Promise.all([
          // getLocationName(latitude, longitude),
          getIPAddress(),
        ]);

        // Construct the insight body
        insightBody = {
          insight_id: null,
          // browserMeta,
          // accuracy,
          // latitude,
          // longitude,
          // timestamp,
          // location,
          ip,
          platform: "https://hopeofanewera.org/",
          // user: sessionUser?.userId,
        };

        console.log("userInsight_insightBody:", insightBody);
        const insight = await getInsight();
        console.log("Insight found", insight);
        // Additional logic for when the insight is found

        if (!insight) {
          //create new cookie
        }

        if (insight?.insight_id) {
          console.log("userInsight_insight_found", insight);
          insightBody.insight_id = insight.insight_id;
          let impressionBody = {
            insight_id: insight.insight_id,
            ip_address: ip,
          };

          let resImpression = await createSiteImpression(impressionBody);
          console.log("userInsight_insightImpression", resImpression);
        }
      } catch (error) {
        console.log("No insight found", error);
        try {
          if (removeInsight()) {
            const insightResponse = await createNewInsight(insightBody);
            console.log("Created new insight:", insightResponse);
            if (insightResponse?.data?.data?.token) {
              setInsight(insightResponse?.data?.data?.token);
              let impressionBody = {
                insight_id: insightResponse?.data?.data?.insight_id,
                ip_address: insightBody.ip,
              };

              let resImpression = await createSiteImpression(impressionBody);
              console.log("userInsight_insightImpression", resImpression);
            }
          }

          // Additional logic for when the insight is not found and a new one is created
        } catch (creationError) {
          console.error("Error creating new insight:", creationError);
          // Handle the error that occurred during the creation of a new insight
        }
      }
    }

    /**
     * Fetches user geolocation, resolves location name and IP address, and creates or updates user insight.
     * If any errors occur during the process, they are caught and logged to the console.
     */
    async function userInsight() {
      try {
        const getList = await getAllTags();
        // console.log("Get All Tags : ", getList);
        if (getList.data) {
          dispatch(setTagsList(getList.data));
          // setTagsListArray(getList.data);
        } else {
          console.log("Data Not Found");
        }
        // Fetch existing insight if it exists
        await handleInsight();
      } catch (error) {
        console.error("Error in userInsight:", error);
      }
    }

    userInsight();
    // Check if cookie already exists
    const promoCookie = getCookie("popup");

    if (!promoCookie) {
      // No cookie => show modal + set cookie
      dispatch(openHomeAdModal());

      // Set cookie that expires in 1 day (24h)
      setCookie("popup", "POPUP_ADVERTISEMENT", { days: 1 });
    }

    setIsOpenAdvertisementModal(true);
    //===================== End =============================
    // fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleChildData = (childData) => {
    setCategory(childData); // Update state with child data
  };

  const handleTagData = (childData) => {
    setTag(childData); // Update state with child data
  };

  // slider
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = (menusList?.langth || 0) + 2; // +2 for "Home" and "Contact us"
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  const settings = {
    variableWidth: true,
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2, //number of items sliding at a time
    initialSlide: 0,
    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
    afterChange: (index) => setCurrentSlide(index),
    nextArrow: (
      <div className="rvow__next">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronRight />,
            buttonType: isLastSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__next",
          }}
        />
      </div>
    ),

    prevArrow: (
      <div className="rvow__prev">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronLeft />,
            buttonType: isFirstSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__prev",
          }}
        />
      </div>
    ),
  };

  // const onChangePage = (pageNumber) => {
  //   console.log("Page: ", pageNumber);
  //   setPage(pageNumber);
  //   let status = 1;
  //   let size = 10;
  //   setIsLoading(true);
  //   if (storeId) {
  //     fetchProductsByStoreId(storeId, pageNumber, 10);
  //   } else {
  //     fetchProductAPI(1, pageNumber, 10);
  //   }
  // };

  return (
    <>
      {isOpenMobileMenuModal && <MobileMenuModal />}
      {isOpenEmailVerificationModal && <EmailVerificationModal />}
      {isOpenEmailChangeModal && <EmailChangeModal />}
      {isOpenProfileCreateModal && <ProfileCompleteModal />}
      {isOpenAdvertisementModal && <AdvertisementModal />}
      {isOpenAd && <HomeAdViewModal />}

      <div className={`console-wrapper `}>
        {/* <div className={"bg-color"}></div> */}
        {/* <div className={"bg-image"}></div>{" "} */}

        <img
          className={`bg__img   `}
          src={bgImage || require("../../assets/img/lgo (1).png")}
          alt={""}
        />

        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClick={() => {
              props.history.push("/");
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>

        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""}`}>
            <div className={"cwt__hope"}>
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={"News, Politics & Global Affairs"}
              />
            </div>
            <div className={`menu ${isSticky ? "sticky" : ""}`}>
              <Menu setMenuName={handleChildData} />
            </div>
            {/* <Slider
              {...settings}
              className={"rpmw__slider d-flex flex-row justify-content-center"}
            >
              <Menu setMenuName={handleChildData} />
            </Slider> */}
            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            > */}
            {/* <Navigator
                data={{ size: "lg", icon: "arrow-left", title: "Contact us" }}
              /> */}
            {/* {GetIconByName("menu")} */}

            {/* </div> */}
          </div>

          {newsUser?.isAccountVerified && !newsUser?.isProfileCompleted && (
            <AccountVerify
              data={{
                title:
                  "Your Profile is not Completed. Please Complete Your Profile.",
                button: "Click here",
              }}
              onClick={async () => {
                try {
                  if (newsUser?.company_id) {
                    // props.history.push("/profile-complete");
                    dispatch(openProfileCreateModal());
                  }
                } catch (error) {
                  console.error(error);
                  notification.error({
                    message: "Error",
                    description:
                      "Failed to load Profile page. Please try again.",
                  });
                }
              }}
            />

            // <div className="cw__verify">
            //   ❗Your Profile is not Completed. Please Complete Your Profile.{" "}
            //   <span
            //     onClick={async () => {
            //       try {
            //         if (newsUser?.company_id) {
            //           props.history.push("/profile-complete");
            //         }
            //       } catch (error) {
            //         console.error(error);
            //         notification.error({
            //           message: "Error",
            //           description:
            //             "Failed to load Profile page. Please try again.",
            //         });
            //       }
            //     }}
            //   >
            //     Click here
            //   </span>
            // </div>
          )}
          <div className={"cw__advertiesment-wrapper"}>
            <div className={"cwaw__first"}>
              <ConsoleTopLeftAdd />
            </div>
            <ConsoleTopRightAdd />
            {/* <div className={"cwa__advertiesment"}>Advertisement with us </div> */}
            {/* <div className={"cwa__advertiesment"}>Advertisement with us </div> */}
          </div>

          {/* <div className={"cw__news"}>
            <div className={"cwn__title"}>උණුසුම් පුවත්</div>
            <div className={"headers-bg"}>
              <div className={"news-ticker"}>
                <div className={"cwn__headers"}>
                  {newsBullets?.map((item, index) => (
                    <NewsHeader
                      key={index}
                      data={{
                        newsContent: item?.title[lan],
                      }}
                      onClick={() => {
                        props.history.push("/news/" + item?.news_id);
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div> */}

          <LiveFeed />

          <div className={"cw__body"}>
            {location.pathname === "/" && (
              <>
                <Home
                  onChangeCategory={handleChildData}
                  onChangeTag={handleTagData}
                  onchangeBGImage={handleChangeImage}
                />
              </>
            )}
            {location.pathname === "/hotnews" && (
              <>
                <HotNews />
              </>
            )}
            {/* {location.pathname === "/gov-jobs" && (
              <>
                <GovernmentJobsPage />
              </>
            )} */}
            {location.pathname !== "/" &&
              location.pathname === "/" + category && (
                <>
                  <CategoryNwsPage onChangeCategory={handleChildData} />
                </>
              )}
            {location.pathname !== "/" &&
              location.pathname ===
                "/tag/" + tag?.tag_name + "/" + tag?.tag_name && (
                <>
                  <TagNewsPage onChangeTag={handleTagData} />
                </>
              )}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default Index;
